import React from 'react';
type PieChartProps = {
  labels: string[];
  values: number[];
  colors: string[];
  height: number;
};
export const PieChart: React.FC<PieChartProps> = ({
  labels,
  values,
  colors,
  height
}) => {
  const total = values.reduce((sum, value) => sum + value, 0);
  let startAngle = 0;
  // Calculate the segments
  const segments = values.map((value, index) => {
    const percentage = value / total * 100;
    const degrees = percentage / 100 * 360;
    const segment = {
      label: labels[index],
      value,
      percentage,
      color: colors[index],
      startAngle,
      endAngle: startAngle + degrees
    };
    startAngle += degrees;
    return segment;
  });
  // SVG Path for each segment
  const createPieSegment = (segment: any, index: number) => {
    const startAngleRad = (segment.startAngle - 90) * (Math.PI / 180);
    const endAngleRad = (segment.endAngle - 90) * (Math.PI / 180);
    const x1 = 100 + 80 * Math.cos(startAngleRad);
    const y1 = 100 + 80 * Math.sin(startAngleRad);
    const x2 = 100 + 80 * Math.cos(endAngleRad);
    const y2 = 100 + 80 * Math.sin(endAngleRad);
    const largeArcFlag = segment.endAngle - segment.startAngle <= 180 ? '0' : '1';
    const pathData = [`M 100 100`, `L ${x1} ${y1}`, `A 80 80 0 ${largeArcFlag} 1 ${x2} ${y2}`, `Z`].join(' ');
    return <path key={index} d={pathData} fill={segment.color} stroke="#fff" strokeWidth="1" data-id="element-468" />;
  };
  return <div style={{
    height: `${height}px`
  }} className="flex flex-col items-center" data-id="element-469">
      <svg width="200" height="200" viewBox="0 0 200 200" data-id="element-470">
        {segments.map(createPieSegment)}
      </svg>
      <div className="mt-4 flex justify-center flex-wrap gap-4" data-id="element-471">
        {segments.map((segment, index) => <div key={index} className="flex items-center" data-id="element-472">
            <div className="w-3 h-3 rounded-full mr-2" style={{
          backgroundColor: segment.color
        }} data-id="element-473"></div>
            <span className="text-sm text-gray-700" data-id="element-474">
              {segment.label} ({segment.percentage.toFixed(0)}%)
            </span>
          </div>)}
      </div>
    </div>;
};